$shm_ba_agent_message_posts $mol_view
	table null
	sub <= rows /
	Post* $shm_ba_post_card
		table <= table null
		post_row <= post_row* null
	Empty $mol_paragraph
		title \Сообщений не найдено
